
var app = angular.module('directives.authMasterpass', []);

require('./directives/authMasterpass.js');
require('./stylesheets/authMasterpass.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/authMasterpass/index.js
 ** module id = 123
 ** module chunks = 1
 **/